






















































































// @ is an alias to /src
import { AloPlat, getDefaultAloPlat } from '@/models/alo/AloPlat'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {IItemPanier, ItemPanier} from '@/models/alo/ItemPanier'
import { VuetifyConfirmObject } from 'node_modules/vuetify-confirm/types'
import { getDefaultAloArbo } from '@/models/alo/AloArbo'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'
import PlatEditable from '@/components/carte/PlatEditable'
import IconBtn from '@/components/shared/IconBtn.vue'
import { groupByNumber } from '@/utils/groupBy'
import CartItem from '@/components/panier/CartItem.vue'


@Component({
  name: 'ProduitOeuf',  
  props:{
    reset:{
      type:Boolean,
      default:false
    }   
  },
  components:{IconBtn,CartItem}
})
export default class ProduitOeuf extends mixins(BasePlat,PlatEditable) {  
  reset!:boolean   
  showTempsCuisson = false
  showConfirmAdd = false

  public selectedPlat:AloPlat = getDefaultAloPlat()

  get typesOeufs(){
    return ['omelette','omelette-blanc','brouilles','brouilles-blanc','auPlat','poches','coque','dur' ]
  }

  get platSelected(){
    return this.plat.selected
  }
  
  get platsDic(){    
    return this.$store.myGetters.platsDic
  }

  get plats() {
    return this.plat.platsIds?.map(id => this.platsDic[id]) || []
  }

  get menuItems() {
    return this.plats.filter(p => p &&  p.template == "plat-produit-accompagnement-oeuf")
  }

  get defaultItems() {
    return this.plats.filter(p => p && p.template == "plat-produit-accompagnement-oeuf-default")
  }


  @Watch("plat")
  onPlatChange(){    
    this.resetItemPanier()
  }

  @Watch("reset")
  onReset(){
    if(this.reset) this.resetItemPanier()
  }

  mounted() {
    //on est dans le cas d'un nouveau panier
    if(this.itemPanier.plat.id == 0) this.resetItemPanier()
  }

  resetItemPanier(){    
    const options = {
      [this.plat.id]:this.defaultItems.map(p => new ItemPanier({plat:p,qty:1}))
    } as {[platId:number]:Array<IItemPanier>}    
    this.itemPanier = new ItemPanier({plat:this.plat,qty:1,options,accompagnements:this.menuItems.map(item => {return {qty:0,item}}),parentId:this.platParentId,sectionId:this.platSectionId,arboId:this.platArboId})
  }


  selectProduct() {  
    this.resetItemPanier()     
    this.$store.myActions.ROOM_SERVICES_PLAT_SET_SELECTION({selected:true,ids:[this.plat.id]})       
  }

  cancel() {
    if(this.isEdited){
      this.$emit("cancel")
    }
    else{    
      this.resetItemPanier()      
    }
  }
  

  showConfirmAddMessage() {    
    if(!this.canAdd)  this.$confirm(this.$t('Cart.AlertProductMix').toString(),{title: this.$t('Cart.AlertProductMixTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
    else {
      if(!this.itemPanier.cuissonOeuf) { 
        this.$confirm(this.$tc('Dish.AlertEggCooking',this.plat.qtyAccompagnementGratuit||0),{title: this.$t('Global.Warning'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
      }
      else if(this.itemPanier.tempsCuisson == -1 && this.itemPanier.cuissonOeuf == "coque") {
        this.$confirm(this.$tc('Dish.AlertTimeCooking',this.plat.qtyAccompagnementGratuit||0),{title: this.$t('Dish.AlertEggCookingTitle'),buttonTrueText:this.$t('Global.Yes'),buttonFalseText:this.$t('Global.No')} as VuetifyConfirmObject).then( (response) => {
            if(response){
              this.itemPanier.tempsCuisson = 0
              this.showConfirmAddMessage()          
            }
          }
        )
      }
      else if(this.itemPanier.nbAccompagnements < (this.plat.qtyAccompagnementGratuit || 0)) { 
        this.$confirm(this.$tc('Dish.AlertSideDishes',this.plat.qtyAccompagnementGratuit||0),{title: this.$t('Dish.AlertSideDishesTitle'),buttonTrueText:this.$t('Global.Yes'),buttonFalseText:this.$t('Global.No')} as VuetifyConfirmObject).then( (response) => {
            if(response){
              this.showConfirmAdd = true
            }
          }
        )
      }    
      else {      
        this.showConfirmAdd = true            
      }
    }
  }

  backToConfig(){
    this.showConfirmAdd = false
    this.itemPanier.qty = 1
  }

  addItemToPanier() { 
    if(!this.canAdd)  this.$confirm(this.$t('Cart.AlertProductMix').toString(),{title: this.$t('Cart.AlertProductMixTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
    else {
      this.showConfirmAdd = false
      this.addToCart(this.itemPanier) 
      this.cancel()      
    }
  }
  
  toggleAccompagnement(plat:AloPlat) {
    const idx = this.itemPanier.options![this.plat.id].findIndex(it => it.plat.id == plat.id)
    if(idx > -1){      
      this.itemPanier.options![this.plat.id].splice(idx,1)
    }
    else{
      this.itemPanier.options![this.plat.id].push(new ItemPanier({plat,qty:1}))
    }

  }

  hasAccompagnement(plat:AloPlat) {
    return this.itemPanier.options 
       && this.itemPanier.options[this.plat.id] 
       && this.itemPanier.options[this.plat.id].findIndex(it => it.plat.id == plat.id) > -1
  }

}
